var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "modal-header" },
      [_vm._t("header", [_c("h3", [_vm._v("How to use the site")])])],
      2
    ),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _vm._t("body", [
          _vm._m(0),
          _c("p", [
            _vm._v(
              "For clarity, this website doesn't display the radius that is shown in the game because it's not useful and just creates confusion. With those things in mind, let's look at an example:"
            )
          ]),
          _c("img", {
            staticClass: "example",
            attrs: { src: "img/example.png", width: "400" }
          }),
          _c("p", [
            _vm._v(
              "Here we have the map that we want to run: Lookout (in Blue). The maps with a green circle are the ones that are in direct contact with this map; therefore, we want good mods here."
            )
          ]),
          _c("p", [
            _vm._v(
              "Next, we have Orange maps--these are the first layer of bad mods. These maps will directly affect the good mods."
            )
          ]),
          _c("p", [
            _vm._v(
              "The final layer, the Red one, will block bad mods from rolling on your Green layer. This stems from the rule that maps can have the same mod only once. Green can't roll the same mod that Red has because they would both affect orange."
            )
          ]),
          _c("p", [
            _vm._v(
              "TTL;DR: Blue and Green= good mods. Orange and Red= bad mods."
            )
          ]),
          _c("p", [
            _vm._v(
              "Sextant blocking can be a complicated issue. Here are some more resources to figure it out:"
            )
          ]),
          _vm._m(1),
          _vm._m(2),
          _c("p")
        ])
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _vm._t("header", [
          _c(
            "button",
            {
              staticClass: "modal-default-button",
              on: {
                click: function($event) {
                  _vm.$emit("close_modal")
                }
              }
            },
            [_vm._v("Close")]
          )
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "The main thing to understand when talking about sextants is that"
      ),
      _c("b", [_vm._v(" a map can only have 1 sextant with the same mod.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "a",
        {
          attrs: {
            href: "https://www.youtube.com/watch?v=p0v3_XX2cqI",
            target: "_blank"
          }
        },
        [_vm._v("Tarke Cat video")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "a",
        { attrs: { href: "https://www.youtube.com/watch?v=LgXc_WHxqVM" } },
        [_vm._v("Grimro Video")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7931acfe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7931acfe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SextantHelp.vue
// module id = 59
// module chunks = 0